const ResetButton = ({ content, ariaLabel, onButtonClick, isDisabled}: {content: string, ariaLabel: string, onButtonClick: ()=>void, isDisabled?: boolean}) => {

    return (
        <button 
            className={`reset-button ${isDisabled ? "inactive" : "active" }`} 
            aria-label={ariaLabel} 
            onClick={onButtonClick}
            disabled={isDisabled}>
                {content}
        </button>
    );
};

export default ResetButton